import http from '@/util/http'
// 请求系统报价
export function addByOrderId (data) {
  return http({
    url: '/api/orderBase/addByOrderId',
    method: 'post',
    data: data
  })
}
// 启用状态快递物流公司
export function queryByState () {
  return http({
    url: '/api/systemLogisticsExpress/queryByState',
    method: 'get'
  })
}
// 请求人工报价
export function orderContentAddByOrderId (cusId, data) {
  return http({
    url: `/api/orderContent/addByOrderId/${cusId}`,
    method: 'post',
    data: data
  })
}
// 移除产品
export function orderContentDelete (data) {
  return http({
    url: '/api/orderContent/delete',
    method: 'post',
    data: data
  })
}
// // 批量修改货期
// export function orderContentUpdateTime (cusId, obId, data) {
//   return http({
//     url: `/api/orderContent/update/${cusId}/${obId}`,
//     method: 'post',
//     data: data
//   })
// }
// 调入报价单
export function orderBaseQueryByOwnId (page, size, state, data) {
  return http({
    url: `/api/orderBase/queryByOwnId/${page}/${size}/${state}`,
    method: 'post',
    data: data
  })
}
// 调入报价单查看产品清单和提交
export function orderContentQueryByOcbId (obId) {
  return http({
    url: `/api/orderContent/queryByOcbId/${obId}`,
    method: 'post'
  })
}
// 调入合同
export function orderBaseQueryAllByOwnId (page, size, data) {
  return http({
    url: `/api/orderContractBase/queryAllByOwnId/${page}/${size}`,
    method: 'post',
    data: data
  })
}
// // 调入合同产品清单和提交
// export function orderContractContentQueryAllProduct (ocbId) {
//   return http({
//     url: `/api/orderContractContent/queryAllContent/${ocbId}`,
//     method: 'post'
//   })
// }
// 产品清单(不分页)  调入合同 产品清单和提交
export function queryOrderContractContent (ocbId) {
  return http({
    url: `/api/orderContractContent/queryOrderContractContent/${ocbId}`,
    method: 'get'
  })
}
// 申请报价单
export function orderBaseAdd (data) {
  return http({
    url: '/api/orderBase/add',
    method: 'post',
    data: data
  })
}
// 根据报价单id生成合同{obId}
export function orderContractBaseQueryByBase (obId, data) {
  return http({
    url: `/api/orderContractBase/queryByBase/${obId}`,
    method: 'post',
    data: data
  })
}
// 询价单列表
export function queryPageAllByObState (page, size, miState, state, data) {
  return http({
    url: `/api/orderBase/queryPageAllByObState/${page}/${size}`,
    method: 'post',
    params: {
      miState: miState,
      state: state
    },
    data: data
  })
}

// 询价单详情
export function orderBaseQueryById (id) {
  return http({
    url: `/api/orderBase/queryById/${id}`,
    method: 'post'
  })
}

// 合同列表
export function orderContractBaseQueryAllByState (page, size, state, data) {
  return http({
    url: `/api/orderContractBase/queryAllByState/${page}/${size}`,
    method: 'post',
    params: {
      state: state
    },
    data: data
  })
}
// 设置期货产品列表
export function queryAllContentProduct (page, size, ocbId) {
  return http({
    url: `/api/orderContractContent/queryAllContent/${page}/${size}/${ocbId}`,
    method: 'post'
  })
}
// 申请审批合同
export function orderContractBaseAdd (data) {
  return http({
    url: '/api/orderContractBase/add',
    method: 'post',
    data: data
  })
}
// 根据合同id查看详情(约定账期/全款发货/先货后款)/(期货期款)
export function orderContractBaseQueryByOcbId (ocbId) {
  return http({
    url: `/api/orderContractBase/queryByOcbId/${ocbId}`,
    method: 'post'
  })
}
// 根据客户id查看合同回款划拨详情
export function queryTransFlowByCusId (cusId) {
  return http({
    url: `/api/orderContractBase/queryTransFlowByCusId/${cusId}`,
    method: 'post'
  })
}
// 根据客户id查看待划拨记录
export function queryCustomerMsgByCusId (cusId, page, size) {
  return http({
    url: `/api/orderContractBase/queryCustomerMsgByCusId/${cusId}/${page}/${size}`,
    method: 'post'
  })
}
// 划拨工单
export function workOrderWithTransfer (ocbId, page, size) {
  return http({
    url: `/api/orderContractSalereturnOrder/workOrderWithTransfer/${ocbId}/${page}/${size}`,
    method: 'post'
  })
}
// 根据合同id查询回款划拨合同金额信息
export function queryTransByOcbId (ocbId) {
  return http({
    url: `/api/orderContractBase/queryTransByOcbId/${ocbId}`,
    method: 'post'
  })
}
// 根据合同id和客户id划拨合同
export function updateContractBaseByOcbIdCusId (ocbId, data) {
  return http({
    url: `/api/orderContractBase/updateContractBaseByOcbIdCusId/${ocbId}`,
    method: 'post',
    data: data
  })
}
// 作废合同/审核不通过(确认弹框)/重新提交审批
export function updateStateByOcbId (ocbId, state) {
  return http({
    url: `/api/orderContractBase/updateStateByOcbId/${ocbId}/${state}`,
    method: 'post'
  })
}
// 合同回款划拨(待划拨客户/欠款客户)
export function queryTransFlowByOcbId (type, page, size, data) {
  return http({
    url: `/api/orderContractBase/queryTransFlowByOcbId/${type}/${page}/${size}`,
    method: 'post',
    data: data
  })
}
// 根据合同id查看财务信息
export function getFinancialInformation (ocbId) {
  return http({
    url: `/api/orderContractBase/queryAccountShipmentByOcbId/${ocbId}`,
    method: 'post'
  })
}
// 根据合同id查看产品清单
export function getProductList (ocbId) {
  return http({
    url: `/api/orderContractContent/queryOrderContractContentByObId/${ocbId}`,
    method: 'post'
  })
}
// 根据合同id查看报缺清单(分页)
export function queryDeliverContentByOcbId (ocbId, page, size) {
  return http({
    url: `/api/orderContractLackContent/queryDeliverContentByOcbId/${ocbId}/${page}/${size}`,
    method: 'post'
  })
}
// 根据合同id申请报缺
export function getOrderContLackDeliverConById (ocbId) {
  return http({
    url: `/api/orderContractLack/queryDeliverContentByOcbId/${ocbId}`,
    method: 'post'
  })
}
// 根据合同id查看备货单(备货管理){id}
export function qorderContractStockupByOcbId (ocbId) {
  return http({
    url: `/api/orderContractStockup/queryCountByOcbId/${ocbId}`,
    method: 'post'
  })
}
// 发起备货(期货)
export function queryShipmentByOcbId (id) {
  return http({
    url: `/api/orderContractStockup/queryShipmentByOcbId/${id}`,
    method: 'post',
    data: {
      criteriaVoList: [],
      queryPageName: ''
    }
  })
}

// 发起备货是否需要审批
export function addStockupCheck (data) {
  return http({
    url: '/api/orderContractStockup/addStockupCheck',
    method: 'post',
    data: data
  })
}

// 提交备货(期货)
export function orderContractStockup (flag, data) {
  return http({
    url: `/api/orderContractStockup/add/${flag}`,
    method: 'post',
    data: data
  })
}

// 销售备货记录
export function queryStockupByOwnId (str, state, page, size, data) {
  return http({
    url: `/api/${str}/${state}/${page}/${size}`,
    method: 'post',
    data: data
  })
}

// 销售备货详情
export function queryByOcsId (id) {
  return http({
    url: `/api/orderContractStockup/queryByOcsId/${id}`,
    method: 'post'
  })
}

// 销售发货记录
// export function queryDeliverByOwnId (state, page, size, data) {
//   return http({
//     url: `/api/orderContractDeliverGoods/queryDeliverByOwnId/${state}/${page}/${size}`,
//     method: 'post',
//     data: data
//   })
// }

// 销售承兑汇票收款记录
export function financeAcceptanceBillRequestQueryByOwnId (page, size, data) {
  return http({
    url: `/api/financeAcceptanceBillRequest/queryByOwnId/${page}/${size}
    `,
    method: 'post',
    data: data
  })
}

// 根据备货单id释放库存
export function orderContractRelease (data) {
  return http({
    url: '/api/orderContractRelease/add',
    method: 'post',
    data: data
  })
}

// 根据合同id查看发货清单(发货管理)
export function orderContractDeliverGoodsByOcbId (ocbId) {
  return http({
    url: `/api/orderContractDeliverGoods/queryByOcbId/${ocbId}`,
    method: 'post'
  })
}

// 根据发货id查看发货详情(物流/快递/自提/仓库配送)
export function queryByOcdId (ocdId) {
  return http({
    url: `/api/orderContractDeliverGoods/queryByOcdId/${ocdId}`,
    method: 'post'
  })
}

// 根据发货单id和产品id查看产品序列号
export function querySerialCodeByOcbIdAndProId (ocdId, proId, data) {
  return http({
    url: `/api/orderContractDeliverGoodsContent/querySerialCodeByOcbIdAndProId/${ocdId}/${proId}`,
    method: 'post',
    data: data
  })
}

// 根据合同id/客户id请求发货(发起发货)
export function queryStockupByObId (cusId, obId) {
  return http({
    url: `/api/orderContractDeliverGoods/queryStockupByObId/${obId}/${cusId}`,
    method: 'post'
  })
}

// 根据合同/备货/客户id发起发货  // 暂无需求
// export function queryStockupByOcsId (obId, ocsId, cusId) {
//   return http({
//     url: `/api/orderContractDeliverGoods/queryStockupByOcsId/${obId}/${ocsId}/${cusId}`,
//     method: 'post'
//   })
// }

// 发起发货
export function deliverGoodsAdd (flag, data) {
  return http({
    url: `/api/orderContractDeliverGoods/add/${flag}`,
    method: 'post',
    data: data
  })
}

// 发起报缺
export function orderContractLack (data) {
  return http({
    url: '/api/orderContractLack/add',
    method: 'post',
    data: data
  })
}

// 根据合同id/客户id申请开票
export function queryByNotInvoiceContent (obId, cusId) {
  return http({
    url: `/api/orderContractInvoice/queryByNotInvoiceContent/${obId}/${cusId}`,
    method: 'post'
  })
}
// 合同内开票是否需要审批
export function doYouNeedApproval (data) {
  return http({
    url: '/api/orderContractInvoice/doYouNeedApproval',
    method: 'post',
    data: data
  })
}
// 确定申请开票
export function orderContractInvoice (flag, data) {
  return http({
    url: `/api/orderContractInvoice/add/${flag}`,
    method: 'post',
    data: data
  })
}

// 根据开票id查看详情(普通发票/合并开票)
export function queryByOciId (ociId) {
  return http({
    url: `/api/orderContractInvoice/queryByOciId/${ociId}`,
    method: 'post'
  })
}

// 根据合同id查看开票记录(票据管理)
export function queryByNotInvoice (ocbId) {
  return http({
    url: `/api/orderContractInvoice/queryByNotInvoiceContent/${ocbId}`,
    method: 'post'
  })
}

// 开票修改物流信息
export function updateById (data) {
  return http({
    url: '/api/orderContractInvoice/updateById',
    method: 'post',
    data: data
  })
}

// 根据开票id和编码申请红字发票
export function redQueryByOciId (ociId, invoiceNumber) {
  return http({
    url: `/api/orderContractInvoiceSub/queryByOciId/${ociId}/${invoiceNumber}`,
    method: 'post'
  })
}

// 根据合同id查看开票清单
export function queryStateByList (ocbId, type) {
  return http({
    url: `/api/orderContractInvoice/queryStateByList/${ocbId}/${type}`,
    method: 'get'
  })
}

// 根据开票id和编码申请红字发票  (红字发票)
export function redSubQueryByOciId (ociId, invoiceNumber) {
  return http({
    url: `/api/orderContractInvoiceSub/queryByOciId/${ociId}/${invoiceNumber}`,
    method: 'get'
  })
}

// 根据红字发票/退票id查看详情
export function queryByFinance (oisId) {
  return http({
    url: `/api/orderContractInvoiceSub/queryByOisId/${oisId}`,
    method: 'get'
  })
}

// 申请开红字发票/退票
export function orderContractInvoiceSubAdd (data) {
  return http({
    url: '/api/orderContractInvoiceSub/add',
    method: 'post',
    data: data
  })
}
// 退票修改物流信息
export function queryLogisticsById (data) {
  return http({
    url: '/api/orderContractInvoiceSub/queryLogisticsById',
    method: 'post',
    data: data
  })
}

// 根据销售合同id申请坏账
export function queryOrderBaseByObcId (ocbId) {
  return http({
    url: `/api/financeBadDebt/queryOrderBaseByObcId/${ocbId}`,
    method: 'get'
  })
}

// 申请坏账
export function financeBadDebtSave (data) {
  return http({
    url: '/api/financeBadDebt/save',
    method: 'post',
    data: data
  })
}

// 坏账申请详情
export function queryFinanceBadDebtByFbdId (fbcId) {
  return http({
    url: `/api/financeBadDebt/queryFinanceBadDebtByFbdId/${fbcId}`,
    method: 'get'
  })
}

// 开票记录
// export function queryStateByListVoice (state, page, size, data) {
//   return http({
//     url: `/api/orderContractInvoice/queryStateByList/${state}/${page}/${size}`,
//     method: 'post',
//     data: data
//   })
// }

// 客户提现记录/团队提现记录
export function financePayQueryByOwnId (type, page, size, data) {
  return http({
    url: `/api/financePay/queryByOwnId/${type}/${page}/${size}`,
    method: 'post',
    data: data
  })
}

// 根据客户id查询可提现余额/银行账号 发起提现页面初始化
export function queryAccountBankByCusId (cusId) {
  return http({
    url: `/api/financePay/queryAccountBankByCusId/${cusId}`,
    method: 'post'
  })
}

// 客户提现
export function financePay (data) {
  return http({
    url: '/api/customerWithdrawalApproval/add',
    method: 'post',
    data: data
  })
}

// 提现详情(付款详情)
export function queryPayRequestByPayNumber (payNumber, type) {
  return http({
    url: `/api/financePay/queryPayRequestByPayNumber/${payNumber}/${type}`,
    method: 'post'
  })
}

// 客户提现/供应商充值退回修改
export function updateReceiptNameByPayNumber (data) {
  return http({
    url: '/api/financePay/updateReceiptNameByPayNumber',
    method: 'post',
    data: data
  })
}

// 根据客户id和交易账户id修改交易账户信息(修改/添加)
export function customerBankUpdate (data) {
  return http({
    url: '/api/customerBank/update',
    method: 'post',
    data: data
  })
}

// 根据客户id查询账户
export function queryAllByCusId (cusId) {
  return http({
    url: `/api/customerBank/queryAllByCusId/${cusId}`,
    method: 'get'
  })
}

// 根据客户id查询账户
export function download (guid) {
  return http({
    url: `/api/systemAttachment/download/${guid}`,
    method: 'get'
  })
}

// 文件上传
export function uploadNoticeFile (data = []) {
  return http({
    url: '/api/systemNotice/addAttachment',
    method: 'post',
    data
  })
}

export function upload (data = []) {
  return http({
    url: '/api/systemAttachment/upload',
    method: 'post',
    data
  })
}
// 承兑汇票上传文件
export function uploadBySite (data = []) {
  return http({
    url: '/api/systemAttachment/uploadBySite',
    method: 'post',
    data
  })
}

// 销售佣金统计
export function queryMoneyByOwnId (data) {
  return http({
    url: '/api/orderContractBase/queryMoneyByOwnId',
    method: 'post',
    data: data
  })
}

// 根据合同id查看资金占用明细
export function orderContractOccupy (ocbId) {
  return http({
    url: `/api/orderContractOccupy/queryByOcbId/${ocbId}`,
    method: 'post'
  })
}

// 销售坏账记录
export function queryFinanceBadDebtListByOwnId (type, page, size, data) {
  return http({
    url: `/api/financeBadDebt/queryFinanceBadDebtListByOwnId/${type}/${page}/${size}`,
    method: 'post',
    data
  })
}

// 根据承兑汇票申请id查询销售承兑汇票收款申请详情
export function queryByOrderId (fabrId) {
  return http({
    url: `/api/financeAcceptanceBillRequest/queryByOrderId/${fabrId}`,
    method: 'post'
  })
}
// 销售发起承兑汇票收款
export function financeAcceptanceBillRequestSave (data) {
  return http({
    url: '/api/financeAcceptanceBillRequest/save',
    method: 'post',
    data
  })
}

// 根据模板和合同id生成pdf文件(前端不需要)
export function queryUploadOcb (ocbId) {
  return http({
    url: `/api/orderContractBase/queryUploadOcb/${ocbId}`,
    method: 'get'
  })
}

// 合同-审核通过待签署-合同预览
export function queryUploadOcbId (ocbId) {
  return http({
    url: `/api/orderContractBase/queryUploadOcbId/${ocbId}`,
    method: 'get'
  })
}

// 合同盖章上传
export function addUpload (ocbId) {
  return http({
    url: '/api/purchaseContractBase/addUpload',
    method: 'post'
  })
}

export function orderBasete (page, size, data) { // 团队询价记录
  return http({
    url: `/api/orderBase/queryByOrgId/${page}/${size}`,
    method: 'post',
    data
  })
}
export function queryPageAllByTeam (page, size, data) { // 团队特价审批列表
  return http({
    url: `/api/customerSpecialPrice/queryPageAllByTeam/${page}/${size}`,
    method: 'post',
    data
  })
}
export function updateByFlag (id) { // 关闭特价
  return http({
    url: `/api/customerSpecialPrice/updateByFlagINTeam/${id}`,
    method: 'post'
  })
}
export function contractRecordTeam (page, size, data) { // 团队 合同记录
  return http({
    url: `/api/orderContractBase/queryByOrgId/${page}/${size}`,
    method: 'post',
    data
  })
}
export function queryAllByTeam (page, size, data) { // 团队 欠款合同清单
  return http({
    url: `/api/orderContractBase/queryAllByTeam/${page}/${size}`,
    method: 'post',
    data
  })
}

export function stockRecordTeam (page, size, data) { // 团队 备货记录
  return http({
    url: `/api/orderContractStockup/queryByOrgId/${page}/${size}`,
    method: 'post',
    data
  })
}
export function shipmentsRecordTeam (page, size, data) { // 团队 发货记录
  return http({
    url: `/api/orderContractDeliverGoods/queryByOrgId/${page}/${size}`,
    method: 'post',
    data
  })
}
export function queryByOrgIdTeam (page, size, data) { // 团队 开票记录
  return http({
    url: `/api/orderContractInvoice/queryByOrgId/${page}/${size}`,
    method: 'post',
    data
  })
}
// 团队 退货记录

export function queryFinanceBadDebtByTeam (page, size, data) { // 团队 坏账管理
  return http({
    url: `/api/financeBadDebt/queryFinanceBadDebtByTeam/${page}/${size}`,
    method: 'post',
    data
  })
}
export function performanceManageTeam (type, page, size, data) { // 团队 业绩管理/销售业绩统计
  return http({
    url: `/api/orderContractBase/queryMoneyByOrgId/${type}/${page}/${size}`,
    method: 'post',
    data
  })
}

export function orderAchievement (data) { // 销售奖惩
  return http({
    url: '/api/orderAchievement/add',
    method: 'post',
    data
  })
}

export function addContractSell (ocbId) { // 合同对比-提交合同
  return http({
    url: `/api/orderContractBase/addContract/${ocbId}`,
    method: 'post'
  })
}

export function updateByIsOpenExtime (ocbId, isOpenExtime) { // 修改销售合同提醒状态
  return http({
    url: `/api/orderContractBase/updateByIsOpenExtime/${ocbId}/${isOpenExtime}`,
    method: 'post'
  })
}

export function customerInvoice (data) { // 修改开票信息
  return http({
    url: '/api/customerInvoice/update',
    method: 'post',
    data
  })
}

export function addEnquiryAffirm (data) { // 销售-询价导入确认
  return http({
    url: '/api/orderContractBase/addEnquiryAffirm',
    method: 'post',
    data
  })
}

export function enquiryCoeDerive (data, str) { // 销售询价-产品导出
  return http({
    url: `/api/orderContractBase/${str}`,
    method: 'post',
    responseType: 'blob',
    data
  })
}

export function queryOtheroptions (data) { // 系统询价 选择方案
  return http({
    url: '/api/orderContent/queryOtheroptions',
    method: 'post',
    data
  })
}

export function queryOtheroptionsToCommit (data) { // 系统 方案选择提交
  return http({
    url: '/api/orderContent/queryOtheroptionsToCommit',
    method: 'post',
    data
  })
}

export function queryPersonOptions (data) { // 人工方案选择
  return http({
    url: '/api/orderContent/queryPersonOptions',
    method: 'post',
    data
  })
}

export function queryPersonOptionsToCommit (data) { // 人工方案选择提交
  return http({
    url: '/api/orderContent/queryPersonOptionsToCommit',
    method: 'post',
    data
  })
}

export function queryNotInStock (page, size, data) { // 未备货
  return http({
    url: `/api/orderContractStockup/queryNotInStock/${page}/${size}`,
    method: 'post',
    time: 300000,
    data
  })
}
export function queryStockByStockStatat (page, size, state, data) { // 备货其他类型的接口(备货审核，备货中，已备货)
  return http({
    url: `/api/orderContractStockup/queryStockByStockStatat/${page}/${size}/${state}`,
    method: 'post',
    data
  })
}
export function saleInitiateStockup (data) { // 提交备货是否满足备货条件
  return http({
    url: '/api/orderContractStockup/saleInitiateStockup',
    method: 'post',
    data
  })
}
export function saleInitiateStockupAadd (flag, data) { // 提交备货
  return http({
    url: `/api/orderContractStockup/saleInitiateStockupAadd/${flag}`,
    method: 'post',
    data
  })
}
export function queryCustomerMsg (cusId) { // 备货 发货 客户数据
  return http({
    url: `/api/orderContractStockup/queryCustomerMsg/${cusId}`,
    method: 'post'
  })
}
export function queryDeliverContent (stats, page, size, data) { // 发货 产品清单
  return http({
    url: `/api/orderContractDeliverGoods/queryDeliverContent/${page}/${size}/${stats}`,
    method: 'post',
    data
  })
}
export function deliverGoodsIsProcess (data) { // 发货是否需要审批
  return http({
    url: '/api/orderContractDeliverGoods/deliverGoodsIsProcess',
    method: 'post',
    data
  })
}
export function deliverGoods (flag, data) { // 发起发货
  return http({
    url: `/api/orderContractDeliverGoods/deliverGoods/${flag}`,
    method: 'post',
    data
  })
}
export function invoiceContent (stats, page, size, data) { // 开票 产品清单
  return http({
    url: `/api/orderContractInvoice/invoiceContent/list/${page}/${size}/${stats}`,
    method: 'post',
    data
  })
}
export function queryInvoiceInfoPersonAndMessage (cusId, data) { // 根据客户id查询开票基本信息和收票人
  return http({
    url: `/api/orderContractInvoice/queryInvoiceInfoPersonAndMessage/${cusId}`,
    method: 'post',
    data
  })
}
export function orderContractApplyForInvoice (data) { // 申请开票 审核
  return http({
    url: '/api/orderContractInvoice/orderContractApplyForInvoice',
    method: 'post',
    data
  })
}
export function orderContractApplyForInvoiceCommit (data) { // 确定申请开票
  return http({
    url: '/api/orderContractInvoice/orderContractApplyForInvoiceCommit',
    method: 'post',
    data
  })
}
export function setDeliveryOrder (ocdId, fileType) { // 出库单
  return http({
    url: `/api/orderContractDeliverGoods/setUpOutboundOrder/${ocdId}/${fileType}`,
    method: 'post'
  })
}
export function setDeliveryOrderByGuid (ocdId, id) { // 出库单guid
  return http({
    url: `/api/orderContractDeliverGoods/setDeliveryOrderByOcbIdSave/${ocdId}`,
    method: 'post',
    params: {
      guid: id,
      fileType: '导入出库单'

    }
  })
}
export function setDeliveryOrderByGuidByGuidDelete (id) { // 删除 出库单
  return http({
    url: '/api/orderContractDeliverGoods/setDeliveryOrderByGuidByGuidDelete',
    method: 'post',
    params: {
      guid: id
    }
  })
}
export function orderDeliverSerialCodeCoe (data) { // 销售发货序列号导出
  return http({
    url: '/api/orderContractDeliverGoods/orderDeliverSerialCodeCoe',
    method: 'post',
    responseType: 'blob',
    data
  })
}
export function orderDeliverGoodCoeDerive (data) { // 删除 出库单
  return http({
    url: '/api/orderContractDeliverGoods/orderDeliverGoodCoeDerive',
    method: 'post',
    responseType: 'blob',
    data
  })
}
export function queryReturnGoodList (id) { // 查看退货清单列表
  return http({
    url: '/api/orderContractSaleReturnGoods/queryReturnGoodList',
    method: 'post',
    params: {
      ocbId: id
    }
  })
}
export function queryDayByOcbId (page, size, data) { //  数据报表-销售日报表
  return http({
    url: `/api/orderContractBase/queryDayByOcbId/${page}/${size}`,
    method: 'post',
    data
  })
}
export function applyForReturn (data) { // 查看退货清单列表
  return http({
    url: '/api/orderContractSaleReturnGoods/applyForReturn',
    method: 'post',
    data
  })
}
export function saleMessageList (ocbId, cusId) { // 售后管理列表
  return http({
    url: `/api/orderContractSaleReturnGoods/saleMessageList/${ocbId}/${cusId}`,
    method: 'post'
  })
}
export function returnDetails (ocsgId, cusId) { // 处理退货
  return http({
    url: `/api/orderContractSaleReturnGoods/returnDetails/${ocsgId}/${cusId}`,
    method: 'post'
  })
}
export function costSettlementCommit (data) { // 提交退货方案
  return http({
    url: '/api/orderContractSaleReturnGoods/costSettlementCommit',
    method: 'post',
    data
  })
}
export function countAdjustment (data) { // 数量调整
  return http({
    url: '/api/orderContractSaleReturnGoods/countAdjustment',
    method: 'post',
    data
  })
}
export function giveUpReturnGoods (ocsgId) { // 放弃退货
  return http({
    url: `/api/orderContractSaleReturnGoods/giveUpReturnGoods/${ocsgId}`,
    method: 'post'
  })
}
export function returnPlainConfirm (ocsgId) { // 返回重新制定方案
  return http({
    url: `/api/orderContractSaleReturnGoods/returnPlainConfirm/${ocsgId}`,
    method: 'post'
  })
}
export function returnRecord (page, size, data) { // 销售退货记录
  return http({
    url: `/api/orderContractSaleReturnGoods/returnRecord/${page}/${size}`,
    method: 'post',
    data
  })
}
export function temReturnRecord (page, size, data) { // 团队退货记录
  return http({
    url: `/api/orderContractSaleReturnGoods/temReturnRecord/${page}/${size}`,
    method: 'post',
    data
  })
}
export function newStockInOrder (ocsgId) { // 退货-新建入库单
  return http({
    url: `/api/orderContractSaleReturnGoods/newStockInOrder/${ocsgId}`,
    method: 'post'
  })
}
export function newStockInOrderCommit (data) { // 退货-新建入库单提交
  return http({
    url: '/api/orderContractSaleReturnGoods/newStockInOrderCommit',
    method: 'post',
    data
  })
}
export function logisticsWarehousing (ocsgId) { // 退货-入库单物流管理
  return http({
    url: `/api/orderContractSaleReturnGoods/logisticsWarehousing/${ocsgId}`,
    method: 'post'
  })
}
export function instockDetails (id, ocsgId) { // 退货-入库单详情
  return http({
    url: `/api/orderContractSaleReturnGoods/instockDetails/${id}/${ocsgId}`,
    method: 'post'
  })
}
export function refundSettlement (ocsgId, ocbId, type) { // 退款结算
  return http({
    url: `/api/orderContractSaleReturnGoods/refundSettlement/${ocsgId}/${ocbId}/${type}`,
    method: 'post'
  })
}
export function refundSettlementCommit (data) { // 退款结算-提交
  return http({
    url: '/api/orderContractSaleReturnGoods/refundSettlementCommit',
    method: 'post',
    data
  })
}
export function forfeitureInvoice (oscgId, ocbId) { // 罚没金开票默认
  return http({
    url: `/api/orderContractSaleReturnGoods/forfeitureInvoice/${oscgId}/${ocbId}`,
    method: 'post'
  })
}
export function forfeitureInvoiceCommit (data) { // 罚没金开票提交
  return http({
    url: '/api/orderContractSaleReturnGoods/forfeitureInvoiceCommit',
    method: 'post',
    data
  })
}
export function forfeitureInvoiceReCommit (oscgId, ocbId, id) { // 重新申请开票
  return http({
    url: `/api/orderContractSaleReturnGoods/forfeitureInvoiceReCommit/${oscgId}/${ocbId}/${id}`,
    method: 'post'
  })
}
export function forfeitureInvoiceDetail (oscgId, ocbId) { // 罚没金开票详情
  return http({
    url: `/api/orderContractSaleReturnGoods/forfeitureInvoiceDetail/${oscgId}/${ocbId}`,
    method: 'post'
  })
}
export function queryDefaultContract (ocsgId) { // 退货合同详情
  return http({
    url: `/api/orderSalereturnContract/queryDefaultContract/${ocsgId}`,
    method: 'post'
  })
}
export function queryDefaultContractAdd (data) { // 生成退货合同
  return http({
    url: '/api/orderSalereturnContract/queryDefaultContractAdd',
    method: 'post',
    data
  })
}
export function updateContractSell (oscId) { // 退货合同-作废合同
  return http({
    url: `/api/orderSalereturnContract/updateContract/${oscId}`,
    method: 'post'
  })
}
export function queryUploadOscId (oscId) { // 退货合同pdf下载路径拼接-合同预览
  return http({
    url: `/api/orderSalereturnContract/queryUploadOscId/${oscId}`,
    method: 'get'
  })
}
export function addContractContrastSell (oscId, data) { // 合同对比提交
  return http({
    url: `/api/orderSalereturnContract/addContractContrast/${oscId}`,
    method: 'post',
    data
  })
}
export function queryUploadOscIdSeal (oscId) { // 退货盖章合同预览
  return http({
    url: `/api/orderSalereturnContract/queryUploadOscIdSeal/${oscId}`,
    method: 'get'
  })
}
export function applyForRefund (ocsgId, type) { // 申请退票列表接口
  return http({
    url: `/api/orderContractSaleReturnGoods/applyForRefund/${ocsgId}/${type}`,
    method: 'post'
  })
}
export function saleRefundTicket (data) { // 退货退票提交接口
  return http({
    url: '/api/orderContractSaleReturnGoods/saleRefundTicket',
    method: 'post',
    data
  })
}
export function ReturnGoodsInvoice (ociId, invoiceNumber, ocsgId) { // 根据开票id和编码申请红字发票(退货)
  return http({
    url: `/api/orderContractSaleReturnGoods/queryByOciIdToReturnGoodsInvoice/${ociId}/${invoiceNumber}/${ocsgId}`,
    method: 'get'
  })
}
export function ReturnGoodsInvoiceCommit (data) { // 退货 红字发票提交
  return http({
    url: '/api/orderContractSaleReturnGoods/queryByOciIdToReturnGoodsInvoiceCommit',
    method: 'post',
    data
  })
}
export function querySaleReturnGoodsList (ocbId) { // 退货产品清单
  return http({
    url: `/api/orderContractSaleReturnGoods/querySaleReturnGoodsList/${ocbId}`,
    method: 'get'
  })
}
export function saleTaskList (page, size, ocbId) { // 任务列表
  return http({
    url: `/api/orderContractSaleReturnGoods/saleTaskList/${page}/${size}/${ocbId}`,
    method: 'get'
  })
}
export function exportSerializableNumber (data) { // 退货-导出序列号
  return http({
    url: '/api/orderContractSaleReturnGoods/exportSerializableNumber',
    method: 'post',
    responseType: 'blob',
    data
  })
}
export function orderAllocation (data) { // 工单划拨
  return http({
    url: '/api/orderContractSaleReturnGoods/orderAllocation',
    method: 'post',
    data
  })
}
// 未备货导出
export function unstockedExport(data) {
  return http({
    url: '/api/orderContractStockup/unstockedExport',
    method: 'post',
    responseType: 'blob',
    data
  })
}
// 已备货导出
export function preparedForExport(data) {
  return http({
    url: '/api/orderContractStockup/preparedForExport',
    method: 'post',
    responseType: 'blob',
    data
  })
}

// 未发货的导出
export function unshippedExport(data) {
  return http({
    url: '/api/orderContractDeliverGoods/unshippedExport',
    method: 'post',
    responseType: 'blob',
    data
  })
}
// 已发货的导出
export function shippedExport(data) {
  return http({
    url: '/api/orderContractDeliverGoods/shippedExport',
    method: 'post',
    responseType: 'blob',
    data
  })
}
// 销售备发货开票记录-开票记录
export function billingRecordExport(data) {
  return http({
    url: '/api/orderContractInvoice/billingRecordExport',
    method: 'post',
    responseType: 'blob',
    data
  })
}
// 销售备发货开票记录-备货记录
export function stockingRecordExport(data) {
  return http({
    url: '/api/orderContractStockup/stockingRecordExport',
    method: 'post',
    responseType: 'blob',
    data
  })
}
// 销售备发货开票记录-发货记录
export function deliveryRecordExport(data) {
  return http({
    url: '/api/orderContractDeliverGoods/deliveryRecordExport',
    method: 'post',
    responseType: 'blob',
    data
  })
}
// 开票产品清单-未开票
export function unbilledExport(data) {
  return http({
    url: '/api/orderContractInvoice/unbilledExport',
    method: 'post',
    responseType: 'blob',
    data
  })
}
// 开票产品清单-已开票
export function invoicedExport(data) {
  return http({
    url: '/api/orderContractInvoice/invoicedExport',
    method: 'post',
    responseType: 'blob',
    data
  })
}
